import React from 'react';
export function ThumbsUpIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9h-3.69l.28-1.62a4 4 0 00-2.14-4.27 1 1 0 00-1.22.25L7.53 9H3a1 1 0 00-1 1v10a1 1 0 001 1h13.68a3 3 0 002.76-1.82l2.28-5.32a3.39 3.39 0 00.28-1.37V12a3 3 0 00-3-3zM7 19H4v-8h3v8zm13-6.51c0 .203-.041.403-.12.59l-2.28 5.31a1 1 0 01-.92.61H9v-8.64l4.16-5A2 2 0 0113.63 7l-.5 2.8a.999.999 0 001 1.17H19a1 1 0 011 1v.52z"
  }));
}